import React, { useRef, useState, useEffect } from "react";
import "../../Stylesheets/FrequentlyAsked/FrequentlyAsked.scss";
import anyquestion from "../../assests/Images/FrequentlyAsked/anyquestions.png";
import validator from "validator";
import Swal from "sweetalert2";

const FrequentlyAsked = () => {
  const [errors, setErrors] = useState({
    name: false,
    phone: false,
    message: false,
  });

  const [toSend, setToSend] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    const nameValid = toSend.name.trim() !== "";
    const phoneValid = validator.isMobilePhone(toSend.phone);

    setErrors({
      name: !nameValid,
      phone: !phoneValid,
      message: toSend.message.trim() === "",
    });

    if (nameValid && phoneValid && toSend.message.trim() !== "") {
      // Your logic to send the email can go here
      // e.g., Call an API or trigger an email sending function

      // After successful submission, you might want to reset the form fields
      setToSend({ name: "", phone: "", message: "" });
      setErrors({ name: false, phone: false, message: false });
    }
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  function preventEKeyPress(event) {
    const key = event.key.toLowerCase();
    if (key === "e" || key === "." || key === "-" || key === "+") {
      event.preventDefault();
    }
  }

  const [text, setText] = useState(
    "The pricing of our Virtual Tour services depends on the size of the building or space we are creating the tour for. Once you reach out to us, we will be able to give you an accurate quote for your requirements. "
  );
  const [selectedButton, setSelectedButton] = useState(1);

  const handleClick1 = (buttonId) => {
    setText(
      "The pricing of our Virtual Tour services depends on the size of the building or space we are creating the tour for. Once you reach out to us, we will be able to give you an accurate quote for your requirements. "
    );
    setSelectedButton(buttonId);
  };

  const handleClick2 = (buttonId) => {
    setText(
      "No special software or device is required to view our Virtual Tours as they can be shared and accessed via a link that can open on any device such as mobiles, tablets, laptops, and even VR headsets. "
    );
    setSelectedButton(buttonId);
  };
  const handleClick3 = (buttonId) => {
    setText(
      "Apart from showcasing the virtual tours on websites, they can also be uploaded to your Google My Business account or shared via a link for your convenience. "
    );
    setSelectedButton(buttonId);
  };
  const handleClick4 = (buttonId) => {
    setText(
      "Yes, our Virtual Tours are interactive as users can move from one place to another on their own, view images, watch videos, or click on links directly from the tour."
    );
    setSelectedButton(buttonId);
  };
  const handleClick5 = (buttonId) => {
    setText(
      "Yes, 100% as you get to showcase your infrastructure and facilities in a truly immersive way that will give you a competitive edge over the competitors. "
    );
    setSelectedButton(buttonId);
  };
  // const handleClick6 = (buttonId) => {
  //   setText(
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type andscrambled it to make a type specimen book."
  //   );
  //   setSelectedButton(buttonId);
  // };
  // const handleClick7 = (buttonId) => {
  //   setText(
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type andscrambled it to make a type specimen book."
  //   );
  //   setSelectedButton(buttonId);
  // };

  const buttonStyles = {
    border: "1px solid #fff",
    borderColor: "#fff",
    fontSize: "20px",
    fontWeight: "400",
    cursor: "pointer",
  };

  const selectedButtonStyles = {
    ...buttonStyles,
    fontWeight: "500",
    border: "1.5px solid #004493",
    boxShadow: "0px 2px 10px #0044934D",
    borderColor: "#004493",
    color: "#004493",
  };
  return (
    <div className="frequently-main-wrapper">
      <div className="frequently-inner-wrapper">
        <div className="frequently-heading">
          <button>
            <span className="frequently" >Frequently Asked </span>
            Question
          </button>
        </div>

        <div className="frequently-box-outer">
          <div className="frequently-box-inner container-fluid">
            <div className="row">
              <div className="col-md-6 box-one">
                <div className="accoridoan-outer-wrapper">
                  {/* accordian */}
                  <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          style={
                            selectedButton === 1
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick1(1)}
                        >
                          How much will it cost to create a 360 Virtual Tour?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                          style={
                            selectedButton === 2
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick2(2)}
                        >
                          How can my customers access these virtual tours?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                          style={
                            selectedButton === 3
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick3(3)}
                        >
                          I don’t have a website, so how will this be useful?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                          style={
                            selectedButton === 4
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick4(4)}
                        >
                          Are these Virtual Tours interactive?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFive">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                          style={
                            selectedButton === 5
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick5(5)}
                        >
                          Are Virtual Tours Worth it?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>

                    {/* <div class="accordion-item">
                      <h2 class="accordion-header" id="headingSix">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                          style={
                            selectedButton === 6
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick6(6)}
                        >
                          I don’t have a website, how will this be useful?{" "}
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingSix"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div> */}

                    {/* <div class="accordion-item">
                      <h2 class="accordion-header" id="headingSeven">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                          style={
                            selectedButton === 7
                              ? selectedButtonStyles
                              : buttonStyles
                          }
                          onClick={() => handleClick7(7)}
                        >
                          How much will it cost to create a 360 Virtual Tour?{" "}
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingSeven"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div className="col-md-12 content-box " id="boxTwo">
                            <div className="answer">
                              <p>{text}</p>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6 box-two">
                <div className="anyquestions-mian-wrapper">
                  <div className="anyquestions-image-wrap">
                    <img
                      src={anyquestion}
                      alt="any question"
                      className="anyquestion-img"
                    ></img>
                    <h3 className="anyquestion-head">Any Questions?</h3>
                    <p className="anyquestion-desc">
                    The quality of our virtual tour services is also reflected in our customer support. So feel free to reach out to us with any and all queries you might have and we will provide with you all the information you require before making your decision. 
                    </p>
                    <button className="btn_contact_us"><a  href="#contact_us_goto">Contact Us Now!</a></button>
        
                  </div>

                  {/* <div className="anyquestion-fields-wrap">
                    <form id="contact-form" ref={form} onSubmit={sendEmail}>
                     
                    <div className="letmeknow">
                        <label>Let Me know <span style={{color: "red"}}>*</span></label>
                        <textarea
                          className="InputBox1"
                          name="message"
                          placeholder="Enter Your Message Here"
                          value={toSend.message}
                          required
                          onChange={handleChange}
                        ></textarea>
                        {errors.message && (
                          <div style={{ textAlign: "left", color: "red" }}>
                            Please enter a message.
                          </div>
                        )}
                      </div>
                     
                      <div className="letmeknow">
                        <label>Name <span style={{color: "red"}}>*</span></label>
                        <input
                          className="InputBox"
                          type="text"
                          name="name"
                          placeholder="Enter Your Name"
                          value={toSend.name}
                          required
                          onChange={handleChange}
                        ></input>
                        {errors.name && (
                          <div style={{ textAlign: "left", color: "red" }}>
                            Please enter a valid name.
                          </div>
                        )}
                      </div>

                      <div className="letmeknow">
                        <label>Phone Number <span style={{color: "red"}}>*</span></label>
                        <input
                          className="InputBox"
                          type="number"
                          name="phone"
                          value={toSend.phone}
                          required
                          onKeyPress={preventEKeyPress}
                          maxLength={10}
                          onChange={handleChange}
                          placeholder="Eg. +91-0000000000"
                        ></input>
                        {errors.phone && (
                          <div style={{ textAlign: "left", color: "red" }}>
                            Please enter a valid phone number.
                          </div>
                        )}
                      </div>

                     
                    </form>
                    <div className="submit-btn-wrap">
                      <button className="submit-btn" onClick={sendEmail}>
                        Submit
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrequentlyAsked;
